import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { loadSalesOrder, showSalesOrder, salesOrderGetById } from 'Reduxes/consignment/salesorder/salesOrderActions'
import TableData from './TableData'
import FormElement from './FormElement'
import Detail from './Detail'

function SalesOrder() {
    const { data, idShow } = useSelector(state => state.salesOrderReducer)
    const dispatch = useDispatch()
    const [content, setContent] = useState('table')

    useEffect(() => {
        dispatch(loadSalesOrder());
    }, [])

    const showTable = () => {
        setContent('table')
    }

    const showDetail = async (id) => {
        dispatch(showSalesOrder(id))
        setContent('detail')
    }

    const showForm = (type) => {
        setContent('form' + type)
    }

    const renderContent = (contentType) => {
        switch (contentType) {
            case 'table':
                return (<TableData showForm={showForm} showDetail={showDetail} />)
            case 'formNew':
                return (<FormElement type="new" showTable={showTable} />)
            case 'formEdit':
                return (<FormElement type="edit" showTable={showTable} />)
            case 'detail':
                return (<Detail showTable={showTable} rowId={idShow} />)
            default:
                return <>Nothing to show here</>
        }
    }

    return (
        <>
            {
                renderContent(content)
            }
        </>
    )
}

export default SalesOrder
